import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';

import { amortizeDollarDiscount } from './utilities';
import { gatherProductTaxes } from './taxes';

export const calculateRewardDiscounts = ({
  compositePrice,
  credit,
  detail,
  discountTaxOrder,
  originalCompositePrice,
  productTotal,
  receiptDetail,
  rewardApplicableSubtotal,
  rewardApplicableSubtotalPlusTaxes,
  rewardCredit,
  rewardLeftOver,
  rewards,
  rewardAppliedToCredit,
}) => {
  _.forEach(rewards, (reward) => {
    let additionalCredit = Big(0);
    if (reward?.percentage) {
      additionalCredit = additionalCredit.add(originalCompositePrice.times(reward.percentage));
      rewardCredit = rewardCredit.plus(additionalCredit);

      if (discountTaxOrder === 'discountsFirst') {
        compositePrice = compositePrice.minus(additionalCredit);
        if (Big(detail.basePriceMult, 'Base Price Mult').eq(1)) {
          rewardAppliedToCredit = true;
          credit = credit.plus(additionalCredit);
        } else {
          productTotal = productTotal.minus(additionalCredit);
        }
      } else {
        rewardAppliedToCredit = true;
        credit = credit.plus(additionalCredit);
      }
      receiptDetail.addReward({
        type: reward.type,
        id: reward.id,
        name: reward.name,
        value: additionalCredit.times(100),
      });
    } else if (reward?.dollar) {
      let rewardData = reward;
      if (discountTaxOrder === 'taxesFirst') {
        const maxDollarDiscount = Big(Math.min(Number(rewardApplicableSubtotalPlusTaxes), reward?.dollar || 0));
        rewardData = { dollar: Number(maxDollarDiscount) };
      }

      const { amortizedDiscount, leftOver } = amortizeDollarDiscount(
        rewardData,
        rewardLeftOver,
        discountTaxOrder === 'taxesFirst' ? rewardApplicableSubtotalPlusTaxes : rewardApplicableSubtotal,
        originalCompositePrice
      );

      additionalCredit = Big(amortizedDiscount);
      rewardCredit = rewardCredit.plus(additionalCredit);
      rewardLeftOver = Big(leftOver);

      if (discountTaxOrder === 'taxesFirst') {
        rewardAppliedToCredit = true;
        credit = credit.plus(additionalCredit);
      } else {
        compositePrice = compositePrice.minus(additionalCredit);
        productTotal = productTotal.minus(additionalCredit);
      }
      receiptDetail.addReward({
        type: reward.type,
        id: reward.id,
        name: reward.name,
        value: additionalCredit.times(100),
      });
    }
  });

  return { compositePrice, credit, productTotal, rewardCredit, rewardLeftOver, rewardAppliedToCredit };
};

export const prepareRewards = ({ appliedRewards, details, products }) => {
  const rewards = [];

  if (!_.isEmpty(appliedRewards)) {
    _.forEach(appliedRewards, ({ brand, copy, id, operator, value }) => {
      const rewardValue = Big(parseFloat(value || 0));
      const rewardBase = { type: brand, name: copy, id };
      if (operator === '$') {
        rewards.push({ ...rewardBase, dollar: rewardValue });
      } else {
        rewards.push({ ...rewardBase, percentage: rewardValue.div(100) });
      }
    });
  }

  const rewardApplicableSubtotal = _.reduce(
    details,
    (accum, detail) =>
      accum.add((detail.mixAndMatch?.adjustedBasePrice || detail.basePrice).times(detail.quantity).round(2, 1)),
    Big(0)
  );

  return {
    rewardApplicableSubtotal,
    rewardApplicableSubtotalPlusTaxes: rewardApplicableSubtotal.plus(gatherProductTaxes(details, products)),
    rewardCredit: Big(0),
    rewardLeftOver: Big(0),
    rewards,
  };
};
